import { gql } from '@apollo/client';

export * from './softwareEscrowUpdateContentTypes.mutation.generated';

export const SOFTWARE_ESCROW_UPDATE_CONTENT_TYPES = gql`
  mutation softwareEscrowUpdateContentTypes($softwareEscrowId: ID!, $requiredContentTypes: [ContentTypeEnum!]!) {
    softwareEscrowUpdateContentTypes(
      input: { softwareEscrowId: $softwareEscrowId, requiredContentTypes: $requiredContentTypes }
    ) {
      success
      errors
      softwareEscrow {
        id
        requiredContentTypes
      }
    }
  }
`;
